const cardSlider = document.querySelectorAll('.slider--section');
const cardApart = document.querySelectorAll('.slider--apart');

let touchOptionValue = false;

const defaultSliderOptions = {
    autoHeight: !cardApart,
    speed: 2200,
    watchOverflow: true,
    observer: true,
    resizeObserver: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: '.button--slider-next',
        prevEl: '.button--slider-prev',
    },
};
const initSlider = (elem) => {
    if (!elem) return;

    const countsElements = elem.querySelectorAll('.card__slide-wrapper');
    const sliderOptions = {...defaultSliderOptions};

    if (countsElements > elem.dataset.slidesPerView) {
        sliderOptions.navigation.hiddenClass = 'apart__slider-button';
    }

    if (!elem.querySelector('.button--slider')) {
        sliderOptions.navigation.nextEl = elem.parentElement.querySelector('.button--slider-next');
        sliderOptions.navigation.prevEl = elem.parentElement.querySelector('.button--slider-prev');
    } else {
        sliderOptions.navigation.nextEl = elem.querySelector('.button--slider-next');
        sliderOptions.navigation.prevEl = elem.querySelector('.button--slider-prev');
    }

    sliderOptions.loop = !!elem.dataset.loop;

    if (elem.hasAttribute('data-autoplay')) {
        sliderOptions.autoplay = {
            delay: 2200,
            disableOnInteraction: false
        };
    }

    if (elem.dataset.slidesPerView > 1) {
        sliderOptions.autoHeight = false;
        sliderOptions.spaceBetween = 20;
        sliderOptions.breakpoints = {
            768: {
                slidesPerView: elem.dataset.slidesPerView - 1,
                spaceBetween: 40,
                allowTouchMove: touchOptionValue
            },
            1325: {
                slidesPerView: elem.dataset.slidesPerView,
                spaceBetween: 40,
                allowTouchMove: touchOptionValue
            }
        };
    } else {
        sliderOptions.effect = 'fade';
        sliderOptions.speed = 1000;
        sliderOptions.fadeEffect = {
            crossFade: true
        };
        sliderOptions.breakpoints = {
            768: {
                allowTouchMove: touchOptionValue
            }
        };
    }

    if (elem.dataset.sliderPagination) {
        sliderOptions.pagination = {
            el: ".slider__pagination",
            type: "fraction",
        }
    } else {
        sliderOptions.pagination = {
            el: ".swiper-pagination",
            clickable: true,
        }
    }

    const swiper = new Swiper(elem, sliderOptions);

    if (elem.parentElement.parentElement.classList.contains('services')) {
        swiper.on('activeIndexChange', function () {
            const button = swiper.slides[swiper.previousIndex].querySelector('.services__link--open');
            if (button)
                button.click();
        });
    }
    window.addEventListener('resize', swiper.updateSlides());
};

if (cardSlider) {
    if (cardSlider.length > 1) {
        cardSlider.forEach((elem) => {
            initSlider(elem);
        });
    } else {
        initSlider(cardSlider[0]);
    }
}